import Trc from './Trc'

export default class TrcRoma extends Trc {
  constructor() {
    super('lyricRoma')
    this.nameExt = '_roma_trc'
  }
}
